import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient from "../../../../api/klydo";

const useApprovePublicationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["approve-publication"],
    mutationFn: ({
      klydoId,
      message,
      timestamp,
    }: {
      klydoId: string;
      message: string;
      /**
       * Admin-scheduling only — the go-live date an admin picked for a klydo with
       * no approved request. See `klydoApiClient.approvePublication`.
       */
      timestamp?: number;
    }) => {
      return klydoApiClient.approvePublication(klydoId, message, timestamp);
    },

    onSettled: (_data, _error, { klydoId }) => {
      queryClient.invalidateQueries({ queryKey: ["klydos"] });
      // The klydo modal reads the single-klydo query, and approving rewrites the
      // whole `public` facet it renders. Without this the modal keeps showing the
      // pre-approval state until the list refetch happens to replace it.
      queryClient.refetchQueries({ queryKey: ["klydo", klydoId] });
    },
  });
};

export default useApprovePublicationMutation;
